// External Dependencies:
import React from 'react'
import { withRouter } from 'react-router'
import { Link } from 'react-router-dom'
import YouTubePlayer from 'react-player/lib/players/YouTube'

class PostCard extends React.Component {
	constructor() {
		super()

		this.state = {
			playVideo: false
		}
	}

	handleClick = ( e ) => {
		const { videoUrl, history } = this.props

		if ( videoUrl ) {
			e.preventDefault()

			this.setState( {
				playVideo: ! this.state.playVideo
			} )
		} else {
			history.push( e.target.href )
		}
	}
	render() {
		const { url, imageUrl, videoUrl, title, date } = this.props
		const { playVideo } = this.state
		const buttonText = videoUrl ? playVideo ? 'Close' : 'Watch' : 'Read'
		const className = playVideo ? 'is-open card -post' : 'card -post'

		return (
			<Link
				to={ url }
				className={ className }
				onClick={ this.handleClick }
			>
				<div className="-inner">
					{ imageUrl &&
						<div className="-image">
							<img className="-bg-right-cover" src={ imageUrl } alt="" />
						</div>
					}

					{ videoUrl &&
						<div className="media-player">
							<YouTubePlayer url={ videoUrl } controls={ true } play={ playVideo } />
						</div>
					}

					{ ( title || date ) &&
						<header>
							{ title &&
								<h3 dangerouslySetInnerHTML={ { __html: title } }></h3>
							}

							{ date &&
								<span className="-sub">{ date }</span>
							}
						</header>
					}
				</div>

				<div className="button">{ buttonText }</div>
			</Link>
		)
	}
}

PostCard.defaultProps = {
	url: false,
	imageUrl: false,
	videoUrl: false,
	image: false,
	title: false,
	date: false
}

export default withRouter( PostCard )



// WEBPACK FOOTER //
// ./components/Card/PostCard.jsx